import SizeContext from 'antd/es/config-provider/SizeContext';
export { SizeContextProvider } from 'antd/es/config-provider/SizeContext';
export default SizeContext;
